/**
 * AttributeMappingContent - Pure component for AttributeMapping steps
 * Single responsibility: Render AttributeMapping component with service logic
 */

import React from 'react';

import { AttributeMapping } from '../../../../components/AttributeMapping';
import type { STEP_NAMES } from '../../constants/steps';
import { useAttributeMappingLogic } from '../../services/stepServices/attributeMappingService';

type StepName = (typeof STEP_NAMES)[keyof typeof STEP_NAMES];

interface AttributeMappingContentProps {
  stepName: StepName;
}

/**
 * AttributeMapping content for account management steps
 */
function AttributeMappingContent({ stepName }: AttributeMappingContentProps) {
  const {
    dynamicConfig,
    initialMappings,
    mandatoryMappings,
    isAttributesLoading,
    handleMappingsChange,
  } = useAttributeMappingLogic({ stepName });

  if (isAttributesLoading) {
    return (
      <div className='flex justify-center items-center h-64'>
        Loading attribute mappings...
      </div>
    );
  }

  return (
    <AttributeMapping
      config={dynamicConfig}
      mandatoryMappings={mandatoryMappings}
      initialMappings={initialMappings}
      onMappingsChange={handleMappingsChange}
      onSave={async () => {}}
      showSaveButton={false}
    />
  );
}

export default AttributeMappingContent;
